import Axios from '@/lib/request'
const LOP_SRT = `?LOP-DN=${process.env.VUE_APP_GW_DOMAIN}`

const BUAPI = {
  getMenu: () => Axios.post(`${process.env.VUE_APP_GW_HOST_PRE}/getUserMenuList${LOP_SRT}`),
  getUser: () => Axios.post(`${process.env.VUE_APP_GW_HOST_PRE}/accountInfo${LOP_SRT}`)
}

export default BUAPI
